import React from "react";

const ChatHeader = ({ onClick, friendUsername }) => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-6">
          <p className="navy">{friendUsername}</p>
        </div>
        <div className="col-6 text-right">
          <button className="btn btn-link text-right pt-0" onClick={onClick}>
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatHeader;
